import PropTypes from "prop-types";

const ConfirmationDialog = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = "Yes",
    cancelText = "No",
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 z-50">
            <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                <div className="px-6 py-4 border-b">
                    <h3 className="text-lg font-semibold text-gray-800 poppins-medium">{title}</h3>
                    {message && <p className="text-gray-600 mt-2 poppins-regular">{message}</p>}
                </div>
                <div className="px-6 py-4 flex justify-end space-x-4">
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                    >
                        {confirmText}
                    </button>
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                    >
                        {cancelText}
                    </button>
                </div>
            </div>
        </div>
    );
};
ConfirmationDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
};

export default ConfirmationDialog;
